import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FaCalculator } from 'react-icons/lib/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NumberFormat from 'react-number-format';

import { withAuth } from '../../actions/';
import { fetchCostModule, fetchObjectCodeFMS } from '../../actions/additional_actions';
import { formatMoney } from '../../utils/budget';
import CostModuleViewForm from './CostModuleViewForm';

class CostModule extends Component {
    constructor(props) {
        super(props);

        this.state = {
            costModules: [this.getInitialCostModule(), this.getInitialCostModule(), this.getInitialCostModule(), this.getInitialCostModule(), 
                this.getInitialCostModule(), this.getInitialCostModule(), this.getInitialCostModule(), this.getInitialCostModule(), this.getInitialCostModule(), 
                this.getInitialCostModule(), this.getInitialCostModule(),],

            objectCodeFMS: this.props,
            showSavedMsg: false,
            showErrdMsg: false,

            totalEAC: 0,
            totalBaseline: 0,
        };

        //this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleExportToExcel = this.handleExportToExcel.bind(this);  
        this.calculateTotals = this.calculateTotals.bind(this);      
    }

    getInitialCostModule() {
        return {
            id: '',
            amountBaseline: '',
            amountEAC: '',
            createdBy: '',
            createdDate: '',
            fmsObjectCodeId: '',
            isActive: '',
            modifiedBy: '',
            modifiedDate: '',
            projectId: this.props.projectId,
            plannedAmount: '',
            committedAmount: '',
        }
    }

    UNSAFE_componentWillMount() {
        this.props.fetchCostModule(this.props.projectId);
        this.props.fetchObjectCodeFMS(this.props.projectId);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.costModules !== nextProps.costModules)
            this.setState({ costModules: nextProps.costModules })
    }

    // handleChange(index, name) {
    //     return (e) => {
    //         let newVal = {...this.state.costModules[index]};
    //         newVal[name] = e.target.value;
    //         const costModules = {...this.state.costModules, newVal};
    //         //this.state.costModules[index][name] = e.target.value;
    //         this.setState({ costModules: costModules });
    //     };
    // }

    handleSubmit(e) {
        const costModules = this.state.costModules;
        const { objectCodeFMS } = this.props;
        const projectId = this.props.projectId;

        for (var i = 0; i < objectCodeFMS.length; i++) {
            costModules[i].fmsObjectCodeId = objectCodeFMS[i].id;
        }

        costModules.forEach(function (item) {
            item.projectId = projectId;
        });

        let method = 'post';
        let url = `projects/${projectId}/costModules`;

        if (costModules.some(c => c.id !== '' && c.id !== 0)) {
            method = 'put';
        }

        if (costModules.some(c => c.amountEAC === '' || c.amountEAC === null || c.amountEAC === undefined || 
                c.amountBaseline === '' ||  c.amountBaseline === null ||  c.amountBaseline === undefined))
                {
            this.setState({ showErrdMsg: true });
            toast.error('Please fill in all fields');
        }
        else
        {
            // convert to numbers
            costModules.forEach(function (item) {
                if (isNaN(item.amountEAC)) {
                    item.amountEAC = parseFloat(item.amountEAC.substr(1).replace(/,/g, ''));            
                }
                if (isNaN(item.amountBaseline)) {
                    item.amountBaseline = parseFloat(item.amountBaseline.substr(1).replace(/,/g, ''));            
                }
            }); 
            return this.makePutOrPostRequest(costModules, method, url);
        }
    }

    makePutOrPostRequest(costModules, method, url) {
        const { projectId } = this.props;
        costModules.projectId = projectId;

        withAuth(
            { method, url, data: costModules },
            () => {
                this.props.fetchCostModule(projectId);
                this.setState({ showSavedMsg: true });
                toast.success('Saved Successfully!');
            },
            this.errorHandler
        )
    }

    handleExportToExcel() {
        const projectId = this.props.projectId;

        let url = `projects/${projectId}/ExportCostModules`;
        let method = 'post';
        let responseType = 'arraybuffer';

        withAuth(
            { method, url, responseType },
            (response) => {
                var data = response.data;
                var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                var blob = new Blob([data], { type: contentType });
                var downloadUrl = window.URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = downloadUrl;
                link.download = 'CostModule.xlsx';
                link.click();
            },
            this.errorHandler
        )
    }

    calculateTotals() {
        const { costModules } = this.state;
        var totalEAC = 0;
        var totalBaseline = 0;

        var eacArray = costModules.filter(item => item.amountEAC !== '' && item.amountEAC !== null);
        eacArray.forEach(function (item) {
            if (isNaN(item.amountEAC)) {
                totalEAC += parseFloat(item.amountEAC.substr(1).replace(/,/g, ''));            
            }
            else
            totalEAC += parseFloat(item.amountEAC);
        });

        var baselineArray = costModules.filter(item => item.amountBaseline !== '' && item.amountBaseline !== null);

        baselineArray.forEach(function (item) {
            if (isNaN(item.amountBaseline)) {
                totalBaseline += parseFloat(item.amountBaseline.substr(1).replace(/,/g, ''));
            }
            else
                totalBaseline += parseFloat(item.amountBaseline);
        });
        this.setState({ totalEAC: totalEAC, totalBaseline: totalBaseline });
    }

    render() {
        const { objectCodeFMS } = this.props;
        const { roleModules } = this.props.permissions.editPrivileges;

        const canSubmit = roleModules !== null && roleModules.includes('Cost module') ? true : false;

        objectCodeFMS.forEach(function (element) {
            element.classNameHeader = '';
        });

        objectCodeFMS.forEach(function (element) {
            if (element.wbSlevel2 === 'Design' && element.wbSlevel3 === 'Design Direct Labor')
                element.classNameHeader = 3;
            else if (element.wbSlevel2 === 'Construction' && element.wbSlevel3 === 'Construction Direct Labor')
                element.classNameHeader = 8;
            else
                element.classNameHeader = 0;
        });

        var totalFmsActual = 0;
        var fmsActualArray = this.state.costModules.filter(item => item.committedAmount !== '' &&  item.committedAmount !== null);

        fmsActualArray.forEach(function (item) {
            totalFmsActual += parseFloat(item.committedAmount);
        });

        var totalFmsPlanned = 0;
        var fmsPlannedArray = this.state.costModules.filter(item => item.plannedAmount !== '' &&  item.plannedAmount !== null);

        fmsPlannedArray.forEach(function (item) {
            totalFmsPlanned += parseFloat(item.plannedAmount);
        });

        return (
            <div>

        {canSubmit
          ? <div>
                {this.state.showSavedMsg &&
                    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={2000}
                        position={'top-center'}
                    />}

                {this.state.showErrdMsg &&
                    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={2000}
                        position={'top-center'}
                    />}

                <div id="costModule" className="row-wide">
                    <div className="col s12">
                        <h4 className="bar-bottom">Cost Module</h4>
                    </div>

                    <div className="col s12" >
                        <div className="table-scroll">
                            <table className="td-table-border th-table-border table-striped">
                                <thead>
                                    <tr>
                                        <th colSpan="3"></th>
                                        <th>Total Project Cost</th>
                                        <th colSpan='3'></th>
                                    </tr>
                                    <tr>
                                        <th>WBS (level 2)</th>
                                        <th>WBS (level 3)</th>
                                        <th>Associated FMS Object Code</th>
                                        <th>Estimate at Completion (EAC)</th>
                                        <th>FMS Actual</th>
                                        <th>FMS Plan (Funded Amt)</th>
                                        <th>Cost Baseline</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {objectCodeFMS.map((item, index) =>
                                        <tr key={item.id}>
                                            {item.classNameHeader === 0
                                                ? null
                                                : <th rowSpan={item.classNameHeader}>{item.wbSlevel2}</th>}
                                            <td>{item.wbSlevel3}</td>
                                            <td>{item.fmsObjectCode}</td>

                                            <td className="bg-white">
                                                <NumberFormat value={this.state.costModules[index].amountEAC} thousandSeparator={true} prefix={'$'} decimalScale={2} 
                                                fixedDecimalScale={true} allowNegative={false}
                                                    onValueChange={(values) => {                                                                                                
                                                        //this.state.costModules[index]['amountEAC'] = values.formattedValue;

                                                        let newVal = {...this.state.costModules[index]};
                                                        newVal.amountEAC = values.formattedValue;
                                                        {/* const costModules = [...this.state.costModules, newVal]; */}
                                                        let costModules = [...this.state.costModules]
                                                        costModules[index] = newVal;
                                                        this.setState({ costModules: costModules });                                                   
                                                    }} />
                                            </td>
                                               
                                            <td>{formatMoney(this.state.costModules[index].committedAmount)}</td>                                     
                                            <td>{formatMoney(this.state.costModules[index].plannedAmount)}</td>

                                            <td className="bg-white">
                                                <NumberFormat value={this.state.costModules[index].amountBaseline} thousandSeparator={true} prefix={'$'} decimalScale={2} 
                                                fixedDecimalScale={true} allowNegative={false}
                                                     onValueChange={(values) => {
                                                         //this.state.costModules[index]['amountBaseline'] = values.formattedValue;

                                                         let newVal = {...this.state.costModules[index]};
                                                         newVal.amountBaseline = values.formattedValue;
                                                         {/* const costModules = [...this.state.costModules, newVal]; */}
                                                         let costModules = [...this.state.costModules]
                                                         costModules[index] = newVal;
                                                         this.setState({ costModules: costModules });      
                                                     }}
                                                />
                                            </td>
                                        </tr>
                                    )}

                                    <tr>
                                        <th>Total</th>
                                        <td colSpan="2"> <button className="btn-save float-right" onClick={this.calculateTotals}>
                                            <span className="margin-right-05"> <FaCalculator size={12} color='#1180BA' /></span>Calculate Totals</button></td>                                      
                                        <td className="bg-white">
                                                  { formatMoney(this.state.totalEAC)}    
                                            </td>
                                        <td>{formatMoney(totalFmsActual)}</td>
                                        <td>{formatMoney(totalFmsPlanned)}</td>
                                        <td className="bg-white">
                                               {formatMoney(this.state.totalBaseline)} 
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="row margin-top-1">
                    <div className="col s12">
                        <button className="btn-save" onClick={this.handleSubmit} disabled={!canSubmit}>
                            Save</button>
                    </div>
                </div>

            </div>

            : <CostModuleViewForm
                   objectCodeFMS={objectCodeFMS}
                   costModules={this.state.costModules}
                   totalFmsActual={totalFmsActual}
                   totalFmsPlanned={totalFmsPlanned} /> }

        </div>
        );
    }
}

CostModule.propTypes = {
    projectId: PropTypes.string.isRequired,
    permissions: PropTypes.object.isRequired,
    costModules: PropTypes.array.isRequired,
    fetchCostModule: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        objectCodeFMS: state.additionalProjectsStore.objectCodeFMS,
        costModules: state.additionalProjectsStore.costModules,
    };
}

export default connect(mapStateToProps, {
    fetchCostModule,
    fetchObjectCodeFMS,
})(CostModule);